import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "arrowLeftCircleFilled"
const ArrowLeftCircleFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10Zm4.975-9.15H9.048l2.373 2.71c.294.339.252.904-.084 1.21-.341.313-.91.265-1.212-.084l-3.616-4.131c-.276-.368-.272-.792-.002-1.125l.002-.002 3.616-4.132a.858.858 0 0 1 1.21-.085c.342.296.382.87.086 1.211l-2.373 2.711h7.927a.858.858 0 0 1 0 1.716Z"
          />
        </svg>
      }
    </span>
  )
}
export default ArrowLeftCircleFilledIcon
